import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  USER_OPERATIONS,
  RESOURCE_TYPE,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  DATE_FORMAT,
  INTERVAL_TYPE,
  CommentFormModal
} from "../../constants";
import defaultStyles from "./EmergencyAsnApproval.module.css";
import "../../cssModules/switch.css";
import { BackButton } from "..";
import { usePlantAndLinesStore } from "../../providers/PlantAndLinesStore/PlantAndLinesStore";
import { withAllowedOperationsProvider } from "../../hocs";
import Table from "../Table/Table";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { useHistory } from "react-router-dom";
import { API } from "../../apis/api";
import { downloadCsv, exportToExcel, getMonthNameWithYear } from "../../utils/utils";
import { buildErrorMessage } from "../../apis/calls";
import moment from "moment";
import EvrNumberToolbar from "../EvrNumberToolbar/EvrNumberToolbar";
import stylesEvr from "../EvrNumberToolbar/EvrNumberToolbar.module.css";
import config from "../../config/config";
import PlanUploadErrorsPopup from "../PlanUploadErrorsPopup/PlanUploadErrorsPopup";
import MonthPlanForm from "../MonthPlanForm/MonthPlanForm";
import AggregateLineDropDownSelector from '../LineDropdownSelector/AggregateLineDropDownSelector';
import EmergencyASNApprovalModal from '../EmergencyASNApprovalModal/EmergencyASNApprovalModal';
import LineDropdownSelector from '../LineDropdownSelector/LineDropdownSelector';

const EmergencyAsnApproval = ({
  setHasActiveEdits,
  handleCountChange,
}) => {
  const ROW_HEIGHT = 38;
  const RESOURCE_OPERATION_UPDATE = USER_OPERATIONS.UPDATE_EVR_QUANTITY;
  const RESOURCE_OPERATION_ADD_CSV = USER_OPERATIONS.ADD_EVR_DATA;
  const { showSuccess,showInternalError, showError ,showLoading , closePopUp} = usePopupManager();
  const [plant] = usePlantAndLinesStore().plantState;
  const [line] = usePlantAndLinesStore().lineState;
  const [isAsnApprovalModalOpen, setISAsnApprovalModalOpen] = useState(
      false,
  );
  const [eAsnFilteredRows, setEAsnFilteredRows] = useState([]);
  const history = useHistory();

  const [styles, setStyles] = useState(defaultStyles);

  const [rowsData, setRowsData] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
  const [selectedRow, setSelectedRow] = useState(null); 
  const [asnCount, setAsnCount] = useState(0);
  const [isPlanErrorsOpen, setIsPlanErrorsOpen] = useState(false);
  const [uploadErrors, setUploadErrors] = useState();
  const [activeMonthNameWithYear, setActiveMonthNameWithYear] = useState(
    getMonthNameWithYear(moment())
  );
  const setCount = (count) => {
    setAsnCount(count);
  };
  const [showForm, setShowForm] = useState(false);
  const openFormPopup = selectedRow => {
    setShowForm(true);
    setSelectedRow(selectedRow);
  };

  const closeFormPopup = () => {
    setShowForm(false);
  };

  // const loadPlanDataOfActiveMonth = () => {
      
  //     return getEmeregencyASNData(startDateString);
  //   };

  const fixedColumns = [
    {
      width: 160,
      title: "Category",
      field: "category",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 160,
      title: "VC",
      field: "vc",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 200,
      title: "Additional Quantity",
      field: "additionalQuantity",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "Status",
      field: "status",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: "Market",
      field: "market",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 240,
      title: "Country Code",
      field: "countryCode",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 170,
      title: "Defence",
      field: "defence",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 170,
      title: "Rolled",
      field: "rolled",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "FBV",
      field: "fbv",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "FBV Vendor Code",
      field: "fbvVendorCode",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "Power Steering",
      field: "powerSteering",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "Build Card Number",
      field: "buildCardNumber",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "Color Code",
      field: "colourCode",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "Plan Date",
      field: "planDate",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "Additional Quantity",
      field: "additionalQuantity",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "Reason",
      field: "reason",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "Agency",
      field: "agency",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "Comment",
      field: "comment",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "Evr Number",
      field: "evrNumber",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "Requested By",
      field: "requestedBy",
      enableSearch: true,
      enableFilter: true,
    },
  ].filter((c) => c);

  // const optionalColumns =[{
  //     width: 180,
  //     title: "Balance Quantity",
  //     field: "completed",
  //     enableSearch: true,
  //     enableFilter: true,
  //   },].filter((c) => c);

  const redirectToApplicationLandingPage = () => {
    history.push("/");
  };

  const getEmeregencyASNData = async (fromDate) => {
    if (plant.value) {
      //setRowsData({ loading: true, ...rowsData });
      //const Month= fromDate.substring(0, 7); 
      
      try {
        showLoading();
        let response = await API.get(API_RESOURCE_URLS.getEmergencyASNData(plant.value, line.value));
        // const updatedData = response.data.map((item, index) => ({
        //   ...item,
        //   id: index + 1 // Serial number starting from 1
        // }));
        setRowsData({
          loading: false,
          data: response.data,
          filteredData: response.data,
        });
        closePopUp();
      } catch (err) {
        console.log(err);
        showInternalError({ error: err });
      }
    }
  };

  

  // const handleDownloadTemplateButtonClick = () => {
  //   const link = document.createElement('a');
  //   link.setAttribute('download', `Emergency-ASN-Approval-template.xlsx`);
  //   exportToExcel(config.APPLICATION_VARIANT,INTERVAL_TYPE.MONTH).then(dataUri => {
  //     link.href = dataUri;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   });
  // };

    

  const prepareJsonHeaderAndValueFormats = () => {
  
      const monthPlanHeaderAndValueFormats = [
        {
          label: "Material Number",
          value: (row) => row.vc,
        },
        {
          label: "Category",
          value: (row) => row.description,
        },
        {
          label: "Market",
          value: (row) => row.validFrom,
        },
        {
          label: "Country Code",
          value: (row) => row.validTo,
        },
        {
          label: "country",
          value: (row) => row.countryCode,
        },
        {
          label: "Actual Quantity",
          value: (row) => row.completed,
        },
      ].filter((c) => c);
  
      return [...monthPlanHeaderAndValueFormats];
    };
  
    // const generateAndDownloadMonthlyProjectionCsvReport = (fetchedData) => {
    //   try {
    //     if (!rowsData.loading) {
    //       const dateValue = moment().format(DATE_FORMAT.ISO);
  
    //       const jsonData = fetchedData;
  
    //       const allMonthPlan = [];
  
    //       const { parseAsync } = require("json2csv");
    //       const fields = prepareJsonHeaderAndValueFormats(allMonthPlan);
    //       const opts = { fields };
    //       parseAsync(jsonData, opts)
    //         .then((csv) => {
    //           const exportedFilename =
    //             "Emergency_ASN_Approval_Report_" +
    //             plant.label +
    //             "_" +
    //             dateValue +
    //             ".csv";
    //           downloadCsv(csv, exportedFilename);
    //         })
    //         .catch((error) =>
    //           console.error(
    //             "Failed to load Emergency ASN, error:" +
    //               buildErrorMessage(error)
    //           )
    //         );
    //     }
    //   } catch (err) {
    //     // console.error(
    //     //   "Failed to download Emergency ASN report, error:" +
    //     //     buildErrorMessage(error)
    //     // );
    //     console.error(buildErrorMessage(err));
    //     const errorMessage = err?.request?.responseText  || showInternalError({ error: err })
    //     showError({
    //         contextText: errorMessage,
    //         info: '',
    //         error: buildErrorMessage(err),
    //     });
    //   }
    // };
    
  
  useEffect(() => {
    handleCountChange(asnCount);
  }, [asnCount, handleCountChange]);

  useEffect(() => {
    setHasActiveEdits(rowsData.data.some((row) => row.edited));
  }, [rowsData.data, setHasActiveEdits]);
  
  useEffect(() => {
      getEmeregencyASNData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [plant.value]);

  const openEAgsnAssignDateModal = () => setISAsnApprovalModalOpen(true);
  const closeEAgsnAssignDateModal = () => setISAsnApprovalModalOpen(false);

  const handleApprove = filteredRows => {
    //setEAgsnFilteredRows(filteredRows);
    setEAsnFilteredRows(filteredRows);
    openEAgsnAssignDateModal();
  };
  const checkIfRowIsSelected = selectedRows => {
    if (selectedRows.length == 1) return true;
    // if (selectedRows.length > 1) {
    //   const checkIfHaveSame = selectedRows.every(function (element) {
    //     return element.lineName === selectedRows[0].lineName;
    //   });
    //   if (checkIfHaveSame) return true;
    // }

    return false;
  };
  
  const handleEmergencyAsnApprove = async (selectedRows, comment, status) => {
    try {
          const payload = {
            id: selectedRows[0].id,
            plant: plant.value,
            line: line.value,
            status: status,
            comments: comment,
          };
          showLoading();
          const response = await API.patch(
            API_RESOURCE_URLS.emrgencyASNApprove,
            payload,
          );
          if (response) {
            closePopUp();
            showSuccess({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: `${DISPLAY_MESSAGES.emergencyASNApprove}`
            });
          }
        }  catch (error) {
              console.error(
                'failed to Approve or Reject ASN, err: ',
                buildErrorMessage(error),
              );
              showInternalError();
        }
    return false;
  }

  return (
    <>
      <div className={styles.backButton}>
        <BackButton
          action="Emergency ASN Approval"
          handleClick={redirectToApplicationLandingPage}
        />
      </div>
      {/* <EvrNumberToolbar
        plantName={plant.label}<div className={styles.selLine}>
                    <span className={styles.selLineText}>Select a Line</span>
                    <LineDropdownSelector />
                  </div>
        handleMonthSelect={setActiveMonthNameWithYear}
      /> */}
      <div className={stylesEvr.RgtTools}>
        <div className={stylesEvr.eAgsnToolbar}>
          <div className={styles.lineSelect}>
            <span className={styles.selectLineSpan}>Select line</span>
             <LineDropdownSelector />
          </div>
        </div>
      </div>
      
      <div className={styles.container}>
        <div className={styles.tableView} style={{ height: "100%" }}>
          <Table
            columns={[...fixedColumns]}
            defaultColumns={[...fixedColumns]}
            rowHeight={ROW_HEIGHT}
            rows={rowsData.filteredData}
            setHasActiveEdits={setHasActiveEdits}
            setAsnCount={setCount}
            isDataLoading={rowsData.loading}
            // primaryAction={{
            //   name: "Update",
            //   actionFn: (selectedRow) => openFormPopup(selectedRow),
            //   authOperation: RESOURCE_OPERATION_UPDATE,
            //   shouldEnable: (selectedRows) => selectedRows.length === 1,
            // }}
            primaryAction={{
                name: 'Approve/Reject',
                actionFn: filteredData => handleApprove(filteredData),
                authOperation: RESOURCE_OPERATION_UPDATE,
                // shouldEnable: selectedRows =>{
                //    checkIfRowIsSelected(selectedRows),
                // }
                shouldEnable: (selectedRows) => checkIfRowIsSelected(selectedRows)
  
                  
                 
            }}
            // secondaryActions={[
            //   {
            //     name: "DOWNLOAD TEMPLATE",
            //     actionFn: () => handleDownloadTemplateButtonClick(),
            //   },
            //   {
            //     name: "DOWNLOAD CSV",
            //     getFilteredData: true,
            //     authOperation: USER_OPERATIONS.GET_ALL_EVR,
            //     shouldEnable: () => true,
            //     actionFn: (filteredData) =>
            //       generateAndDownloadMonthlyProjectionCsvReport(filteredData),
            //   },
            // ]}
          />
        </div>
      </div>
      {isAsnApprovalModalOpen ? (
              <EmergencyASNApprovalModal
                open={isAsnApprovalModalOpen}
                handleClose={closeEAgsnAssignDateModal}
                title="Emergency ASN Approval"
                rowsData={eAsnFilteredRows}
                lineBackgroundColor="#82C1A7"
                handleSubmit={handleEmergencyAsnApprove}
              />
              // <CommentFormModal
              //           open={isAsnApprovalModalOpen}
              //           handleClose={closePullBackModal}
              //           title="Emergency ASN Approval"
              //           rowsData={eAsnFilteredRows}
              //           reasons={aggregateReasons}
              //           agencies={aggregateAgencies}
              //           lineBackgroundColor="#82C1A7"
              //           handleSubmit={(rows, reason, agency, comment) => {
              //             handleEmergencyAsnApprove(rows, reason, agency, comment);
              //           }}
              //         />
      ) : null}
    </>
  );
};

EmergencyAsnApproval.propTypes = {
  hasActiveEdits: PropTypes.bool.isRequired,
  setHasActiveEdits: PropTypes.func.isRequired,
};

export default withAllowedOperationsProvider(
EmergencyAsnApproval,
  false,
  RESOURCE_TYPE.EVR_QUANTITY
);